import { useObserver } from "mobx-react";
import React from "react";
import { Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  onCheck: () => void;
};

export function ApproveBox(props: Props) {
  const classes = useStyles({});

  return useObserver(() => {
    return (
      <Grid item xs={12}>
        <FormControlLabel
          style={{ float: "right" }}
          control={
            <Checkbox
              checked={false}
              className={classes.approve}
              onChange={(e, checked) => {
                checked && props.onCheck();
              }}
              value="validate"
              color="secondary"
            />
          }
          label={<Typography className={classes.approve}>{locale.Approve}</Typography>}
          labelPlacement="start"
        />
      </Grid>
    );
  });
}

const useStyles = makeStyles((theme: ThemeType) => ({
  approve: {
    color: theme.palette.error.main
  }
}));
